export default {
  m_queryGoodsZeroCategory: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/queryGoodsZeroCategory'
  }
};